<template>
  <div>
    <MainHeader />
    <main class="autopricing-admin-wrapp">
      <v-container
        fluid
        class="grey lighten-5"
      >
        <h2 class="mb-3">
          Notifications
        </h2>
        <VDivider class="mb-6" />
        <v-row
          align="center"
          style="padding: 40px"
        >
          <v-col cols="6">
            <h4>
              Notify about End User rates deviation
            </h4>
            <p>
              When rate, given to customer, deviates from market rates too much
            </p>
          </v-col>
          <v-col cols="6">
            <div class="d-flex">
              <v-text-field
                v-model="marketEmail"
                label="E-mail (overrides default recipient list)"
                placeholder="E-mail"
                outlined
              />
              <v-btn
                class="float-right ml-4"
                color="primary"
                x-large
                :disabled="marketLoaded"
                :loading="marketLoaded"
                @click="notifyEndUserRatesDeviateFromMarketRates"
              >
                Notify!
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6">
            <h4>
              Notify About Existing Manual Rates
            </h4>
            <p>
              Simple summary of existing manual rates for every tenant
            </p>
          </v-col>
          <v-col cols="6">
            <div class="d-flex">
              <v-text-field
                v-model="manualEmail"
                label="E-mail (overrides default recipient list)"
                placeholder="E-mail"
                outlined
              />
              <v-btn
                class="float-right ml-4"
                color="primary"
                x-large
                :disabled="manualLoaded"
                :loading="manualLoaded"
                @click="notifyAboutExistingSetOfManualRates"
              >
                Notify!
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6">
            <h4>
              Notify When Corridors Are Missing
            </h4>
            <p>
              Cross check with enabled corridors on Dashboard/'Destination countries' page.
            </p>
          </v-col>
          <v-col cols="6">
            <div class="d-flex">
              <v-text-field
                v-model="missingEmail"
                label="E-mail (overrides default recipient list)"
                placeholder="E-mail"
                outlined
              />
              <v-btn
                class="float-right ml-4"
                color="primary"
                x-large
                :disabled="missingLoaded"
                :loading="missingLoaded"
                @click="notifyWhenCorridorsAreMissing"
              >
                Notify!
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6">
            <h4>
              Notify About Summaries
            </h4>
            <p>
              Total of existing number of records (automated/manual)
            </p>
          </v-col>
          <v-col cols="6">
            <div class="d-flex">
              <v-text-field
                v-model="summariesEmail"
                label="E-mail (overrides default recipient list)"
                placeholder="E-mail"
                outlined
              />
              <v-btn
                class="float-right ml-4"
                color="primary"
                x-large
                :disabled="summariesLoaded"
                :loading="summariesLoaded"
                @click="notifyAboutSummaries"
              >
                Notify
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6">
            <h4>
              Notify About Deviations Between Market/Provider rates
            </h4>
            <p>
              New notifications to check if diff between market and provider rates is more then 10%
            </p>
          </v-col>
          <v-col cols="6">
            <div class="d-flex">
              <v-text-field
                v-model="providerRateDeviationEmail"
                label="E-mail (overrides default recipient list)"
                placeholder="E-mail"
                outlined
              />
              <v-btn
                class="float-right ml-4"
                color="primary"
                x-large
                :disabled="providerRateDeviationLoaded"
                :loading="providerRateDeviationLoaded"
                @click="notifyAboutProviderRateDeviations"
              >
                Notify!
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6">
            <h4>
              Notify About Deviations Between Dashboards
            </h4>
            <p>
              Pricing FX: New notifications to check diff between dashboards (TR/DH portal)
            </p>
          </v-col>
          <v-col cols="6">
            <div class="d-flex">
              <v-text-field
                v-model="deviationsDashboardsEmail"
                label="E-mail (overrides default recipient list)"
                placeholder="E-mail"
                outlined
              />
              <v-btn
                class="float-right ml-4"
                color="primary"
                x-large
                :disabled="deviationsDashboardsLoaded"
                :loading="deviationsDashboardsLoaded"
                @click="notifyAboutDeviationsBetweenDashboards"
              >
                Notify
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-container
        fluid
        class="grey lighten-5 mb-6 mt-6"
      >
        <h2 class="mb-3">
          Processes
        </h2>
        <VDivider class="mb-6" />
        <v-row
          align="center"
          style="padding: 40px"
        >
          <v-col cols="6">
            <h4>
              Update the payout partner rates and run recalculation of all rates.
            </h4>
            <p>
              Runs Provider ETL (1. Pulling provider rates from payout partners, 2. triangulates, 3. recalculates, 4. applies rates).
            </p>
          </v-col>
          <v-col cols="6">
            <v-btn
              class="float-right ml-4"
              color="primary"
              x-large
              :disabled="providerETLLoaded"
              :loading="providerETLLoaded"
              @click="runProviderRatesETL"
            >
              Run
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          align="center"
          style="padding: 40px"
        >
          <v-col cols="6">
            <h4>
              Sync sending currencies with middleware and re-apply if changed.
            </h4>
            <p>
              Scans active pricing records per tenant, updates sending currency from middleware source-country table, and recalculates impacted rates.
            </p>
          </v-col>
          <v-col cols="6">
            <v-btn
              class="float-right ml-4"
              color="primary"
              x-large
              :disabled="sendingCurrencySyncLoading"
              :loading="sendingCurrencySyncLoading"
              @click="syncSendingCurrencies"
            >
              Sync sending currencies
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-container
        fluid
        class="grey lighten-5 mb-6 mt-6"
      >
        <h2 class="mb-3">
          Remitfinder
        </h2>
        <VDivider class="mb-6" />
        <v-row style="padding: 0 40px">
          <v-col cols="12">
            <h4>
              Send limits source
            </h4>
            <p class="mb-0">
              Where remitfinder reads the send min and max amounts from, per middleware instance.
              "New" uses the transfer row per currency and falls back to the old columns when a currency has no row.
            </p>
          </v-col>
        </v-row>
        <v-row
          v-for="setting in remitfinderSettings"
          :key="setting.instance"
          align="center"
          style="padding: 8px 40px"
        >
          <v-col cols="6">
            <h4>{{ setting.instanceName }}</h4>
            <p
              v-if="setting.updatedBy"
              class="text-caption mb-0"
            >
              Last changed by {{ setting.updatedBy }} at {{ formatDateTime(setting.updatedAt) }}
            </p>
          </v-col>
          <v-col cols="6">
            <div class="d-flex align-center justify-end">
              <v-select
                v-model="remitfinderSendLimitSource[setting.instance]"
                :items="sendLimitSourceOptions"
                item-text="text"
                item-value="value"
                label="Send limits source"
                style="max-width: 360px"
                :loading="remitfinderSettingsLoading"
                :disabled="remitfinderSettingsLoading || remitfinderSettingsSaving === setting.instance"
                hide-details
              />
              <v-btn
                class="ml-4"
                color="primary"
                x-large
                :disabled="remitfinderSettingsLoading || remitfinderSettingsSaving !== null || remitfinderSendLimitSource[setting.instance] === setting.sendLimitSource"
                :loading="remitfinderSettingsSaving === setting.instance"
                @click="saveRemitfinderSettings(setting.instance)"
              >
                Save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-container
        fluid
        class="mb-8 mt-8 pa-0"
      >
        <v-card
          class="payout-configs-card"
          elevation="0"
          rounded="lg"
        >
          <div class="pc-header">
            <div>
              <div class="d-flex align-center">
                <h2 class="pc-title">
                  Payout Configs
                </h2>
                <span class="pc-count">{{ filteredPayoutConfigs.length }}</span>
              </div>
              <p class="pc-subtitle">
                Synced from middleware payout partners and enabled source country overrides (a row with a
                Source Country routes that country only and wins over the default). Resync diffs against the
                middleware and applies changes (partial Provider ETL + FX recalculation per difference).
              </p>
            </div>
            <div class="d-flex align-center flex-shrink-0">
              <v-btn
                icon
                class="mr-3"
                :disabled="payoutConfigsLoading"
                title="Reload"
                @click="loadPayoutConfigs"
              >
                <v-icon color="grey darken-1">
                  mdi-refresh
                </v-icon>
              </v-btn>
              <v-btn
                color="primary"
                depressed
                class="text-none px-5"
                rounded
                :disabled="resyncLoading"
                :loading="resyncLoading"
                @click="resyncPayoutConfigs"
              >
                <v-icon
                  left
                  small
                >
                  mdi-sync
                </v-icon>
                Resync {{ payoutConfigMiddleware ? middlewareLabel(payoutConfigMiddleware) : "all" }}
              </v-btn>
            </div>
          </div>

          <div class="pc-toolbar">
            <div class="pc-filter-group">
              <span class="pc-filter-label">Middleware</span>
              <v-btn-toggle
                v-model="payoutConfigMiddleware"
                dense
                color="primary"
                class="pc-toggle"
              >
                <v-btn
                  :value="null"
                  small
                  class="text-none"
                >
                  All
                </v-btn>
                <v-btn
                  v-for="mw in middlewares"
                  :key="mw.value"
                  :value="mw.value"
                  small
                  class="text-none"
                >
                  {{ mw.text }}
                </v-btn>
              </v-btn-toggle>
            </div>
            <div class="pc-filter-group">
              <span class="pc-filter-label">Channel</span>
              <v-btn-toggle
                v-model="payoutConfigChannel"
                dense
                color="primary"
                class="pc-toggle"
              >
                <v-btn
                  :value="null"
                  small
                  class="text-none"
                >
                  All
                </v-btn>
                <v-btn
                  value="p2p"
                  small
                  class="text-none"
                >
                  P2P
                </v-btn>
                <v-btn
                  value="b2c"
                  small
                  class="text-none"
                >
                  Agency
                </v-btn>
              </v-btn-toggle>
            </div>
            <div class="pc-search">
              <v-text-field
                v-model="payoutConfigSearch"
                placeholder="Search country, currency, type, provider..."
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                hide-details
                clearable
                class="pc-search-field"
              />
            </div>
          </div>

          <v-data-table
            class="pc-table"
            :headers="payoutConfigHeaders"
            :items="filteredPayoutConfigs"
            :search="payoutConfigSearch"
            :loading="payoutConfigsLoading"
            :items-per-page="25"
            :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
          >
            <template v-slot:item.middleware="{ item }">
              <span :class="['pc-badge', `pc-badge--${middlewareColor(item.middleware)}`]">
                {{ middlewareLabel(item.middleware) }}
              </span>
            </template>
            <template v-slot:item.channel="{ item }">
              <span :class="['pc-badge', item.channel === 'p2p' ? 'pc-badge--blue' : 'pc-badge--orange']">
                {{ channelLabel(item.channel) }}
              </span>
            </template>
            <template v-slot:item.createdAt="{ item }">
              <span class="pc-date">{{ formatDateTime(item.createdAt) }}</span>
            </template>
            <template v-slot:item.updatedAt="{ item }">
              <span class="pc-date">{{ formatDateTime(item.updatedAt) }}</span>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </main>

    <v-dialog
      v-if="responseDialogData"
      v-model="showSuccessDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title
          class="text-h5 green lighten-2"
        >
          <b class="white--text text--lighten-1">Success</b>
        </v-card-title>
        <v-card-text>
          <br>
          <b>HTTP Code</b>: {{ responseDialogData.status }} <br>
          <span v-if="responseDialogData.statusText">
            <b>Status Text</b>: {{ responseDialogData.statusText }} <br>
          </span>
          <br>
          Request was Successful
        </v-card-text>
        <v-card-actions>
          <VSpacer />
          <v-btn
            color="green darken-1"
            text
            @click="showSuccessDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showEtlKickoffDialog"
      max-width="420"
    >
      <v-card>
        <v-card-title class="text-h6">
          <v-icon
            color="success"
            left
          >
            mdi-check-circle
          </v-icon>
          Resync complete
        </v-card-title>
        <v-card-text>
          Payout configs are synced. A Provider ETL run has been started to recalculate rates
          with the updated configs. Changes will be reflected in a few minutes.
        </v-card-text>
        <v-card-actions>
          <VSpacer />
          <v-btn
            color="primary"
            text
            @click="showEtlKickoffDialog = false"
          >
            Got it
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="pageLoading">
      <VProgressCircular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-snackbar
      v-model="toastVisible"
      :color="toastColor"
      :timeout="4000"
      top
      right
    >
      {{ toastMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService";
import MainHeader from "@/components/MainHeader";

export default {
  name: "AutopricingAdmin",
  components: {
    MainHeader
  },
  data() {
    return {
      pageLoading: false,
      providerRateDeviationLoaded: false,
      providerRateDeviationEmail: '',
      deviationsDashboardsLoaded: false,
      deviationsDashboardsEmail: '',
      marketLoaded: false,
      marketEmail: '',
      manualLoaded: false,
      manualEmail: '',
      missingLoaded: false,
      missingEmail: '',
      summariesLoaded: false,
      summariesEmail: '',
      showSuccessDialog: false,
      clearFxRatesLoaded: false,
      providerETLLoaded: false,
      marketRatesETLLoaded: false,
      applyRecordsLoaded: false,
      recalculateRecordsLoaded: false,
      recalculateTriangulatedLoaded: false,
      responseDialogData: null,
      sendingCurrencySyncLoading: false,
      toastVisible: false,
      toastMessage: "",
      toastColor: "success",
      payoutConfigs: [],
      payoutConfigsLoading: false,
      resyncLoading: false,
      showEtlKickoffDialog: false,
      payoutConfigMiddleware: null,
      payoutConfigChannel: null,
      payoutConfigSearch: "",
      remitfinderSettings: [],
      remitfinderSendLimitSource: {},
      remitfinderSettingsLoading: false,
      remitfinderSettingsSaving: null,
      sendLimitSourceOptions: [
        { text: "Old (source_country min/max columns)", value: "SOURCE_COUNTRY" },
        { text: "New (currency_operation_limits transfer row)", value: "CURRENCY_OPERATION_LIMITS" }
      ],
      middlewares: [
        { text: "TalkRemit", value: "TALKREMIT", color: "indigo" },
        { text: "Dahab Portal", value: "DAHAB_PORTAL", color: "teal" },
        { text: "USA", value: "USA", color: "slate" }
      ],
      payoutConfigHeaders: [
        { text: "Middleware", value: "middleware" },
        { text: "Source Country", value: "sourceCountryIso3" },
        { text: "Country", value: "countryIso3" },
        { text: "Currency", value: "currency" },
        { text: "Type", value: "type" },
        { text: "Provider", value: "provider" },
        { text: "Channel", value: "channel" },
        { text: "Created", value: "createdAt" },
        { text: "Updated", value: "updatedAt" }
      ]
    };
  },
  computed: {
    filteredPayoutConfigs() {
      return this.payoutConfigs.filter(config =>
        (!this.payoutConfigMiddleware || config.middleware === this.payoutConfigMiddleware) &&
        (!this.payoutConfigChannel || config.channel === this.payoutConfigChannel)
      );
    }
  },
  mounted() {
    this.loadPayoutConfigs();
    this.loadRemitfinderSettings();
  },
  methods: {
    loadRemitfinderSettings() {
      this.remitfinderSettingsLoading = true;

      AdminService.getRemitfinderSettings()
        .then(res => {
          this.remitfinderSettings = res.data;
          this.remitfinderSendLimitSource = Object.fromEntries(
            res.data.map(setting => [setting.instance, setting.sendLimitSource])
          );
        })
        .catch(error => {
          const message = error?.response?.data?.message || "Failed to load remitfinder settings";
          this.showToast(message, "error");
        })
        .finally(() => {
          this.remitfinderSettingsLoading = false;
        });
    },
    async saveRemitfinderSettings(instance) {
      this.remitfinderSettingsSaving = instance;

      try {
        const res = await AdminService.updateRemitfinderSettings(instance, {
          sendLimitSource: this.remitfinderSendLimitSource[instance]
        });
        this.remitfinderSettings = this.remitfinderSettings.map(setting =>
          setting.instance === instance ? res.data : setting
        );
        this.$set(this.remitfinderSendLimitSource, instance, res.data.sendLimitSource);
        this.showToast(`Remitfinder send limits source saved for ${res.data.instanceName}`, "success");
      } catch (error) {
        const message = error?.response?.data?.message || "Failed to save remitfinder settings";
        this.showToast(message, "error");
      } finally {
        this.remitfinderSettingsSaving = null;
      }
    },
    channelLabel(value) {
      return value === "b2c" ? "Agency" : "P2P";
    },
    middlewareLabel(value) {
      const middleware = this.middlewares.find(mw => mw.value === value);
      return middleware ? middleware.text : value;
    },
    middlewareColor(value) {
      const middleware = this.middlewares.find(mw => mw.value === value);
      return middleware ? middleware.color : "grey";
    },
    formatDateTime(value) {
      return value ? value.replace("T", " ").slice(0, 16) : "";
    },
    loadPayoutConfigs() {
      this.payoutConfigsLoading = true;

      AdminService.getSyncedPayoutConfigs()
        .then(res => {
          this.payoutConfigs = res.data;
        })
        .catch(error => {
          const message = error?.response?.data?.message || "Failed to load payout configs";
          this.showToast(message, "error");
        })
        .finally(() => {
          this.payoutConfigsLoading = false;
        });
    },
    async resyncPayoutConfigs() {
      this.resyncLoading = true;
      this.pageLoading = true;

      try {
        await AdminService.resyncPayoutConfigs(this.payoutConfigMiddleware);
        this.loadPayoutConfigs();
        this.showEtlKickoffDialog = true;
        // fire and forget: the dialog already tells the user changes will land later
        AdminService.runProviderRatesETL().catch(() => {
          this.showToast("Provider ETL failed to start after resync", "error");
        });
      } catch (error) {
        const message = error?.response?.data?.message || "Payout config resync failed";
        this.showToast(message, "error");
      } finally {
        this.resyncLoading = false;
        this.pageLoading = false;
      }
    },
    async runProviderRatesETL() {
      this.providerETLLoaded = true;
      this.pageLoading = true;

      try {
        // refresh payout configs from middleware first; ETL still runs if the sync fails
        await AdminService.resyncPayoutConfigs().catch(() => {
          this.showToast("Payout config sync failed, running ETL anyway", "error");
        });

        const res = await AdminService.runProviderRatesETL();
        this.responseDialogData = res;
        this.showSuccessDialog = true;
      } catch (error) {
        const message = error?.response?.data?.message || "Provider ETL failed";
        this.showToast(message, "error");
      } finally {
        this.providerETLLoaded = false;
        this.pageLoading = false;
      }
    },
    notifyEndUserRatesDeviateFromMarketRates() {
      this.marketLoaded = true;
      this.pageLoading = true;

      AdminService.notifyEndUserRatesDeviateFromMarketRates({emailOverride: this.marketEmail})
        .then(res => {
          this.responseDialogData = res;
          this.showSuccessDialog = true;
        })
        .finally(() => {
          this.marketLoaded = false;
          this.pageLoading = false;
        });
    },
    notifyAboutExistingSetOfManualRates() {
      this.manualLoaded = true;
      this.pageLoading = true;

      AdminService.notifyAboutExistingSetOfManualRates({emailOverride: this.manualEmail})
        .then(res => {
          this.responseDialogData = res;
          this.showSuccessDialog = true;
        })
        .finally(() => {
          this.manualLoaded = false;
          this.pageLoading = false;
        });
    },
    notifyWhenCorridorsAreMissing() {
      this.missingLoaded = true;
      this.pageLoading = true;

      AdminService.notifyWhenCorridorsAreMissing({emailOverride: this.missingEmail})
        .then(res => {
          this.responseDialogData = res;
          this.showSuccessDialog = true;
        })
        .finally(() => {
          this.missingLoaded = false;
          this.pageLoading = false;
        });
    },
    notifyAboutSummaries() {
      this.summariesLoaded = true;
      this.pageLoading = true;

      AdminService.notifyAboutSummaries({emailOverride: this.summariesEmail})
        .then(res => {
          this.responseDialogData = res;
          this.showSuccessDialog = true;
        })
        .finally(() => {
          this.summariesLoaded = false;
          this.pageLoading = false;
        });
    },
    notifyAboutProviderRateDeviations() {
      this.providerRateDeviationLoaded = true;
      this.pageLoading = true;

      AdminService.notifyAboutProviderRateDeviations({emailOverride: this.providerRateDeviationEmail})
        .then(res => {
          this.responseDialogData = res;
          this.showSuccessDialog = true;
        })
        .finally(() => {
          this.providerRateDeviationLoaded = false;
          this.pageLoading = false;
        });
    },
    notifyAboutDeviationsBetweenDashboards() {
      this.deviationsDashboardsLoaded = true;
      this.pageLoading = true;

      AdminService.notifyAboutDeviationsBetweenDashboards({emailOverride: this.deviationsDashboardsEmail})
        .then(res => {
          this.responseDialogData = res;
          this.showSuccessDialog = true;
        })
        .finally(() => {
          this.deviationsDashboardsLoaded = false;
          this.pageLoading = false;
        });
    },
    async syncSendingCurrencies() {
      this.sendingCurrencySyncLoading = true;
      this.pageLoading = true;

      try {
        await AdminService.syncSendingCurrencies();
        this.showToast("Sending currency sync completed", "success");
      } catch (error) {
        const message = error?.response?.data?.message || "Sending currency sync failed";
        this.showToast(message, "error");
      } finally {
        this.sendingCurrencySyncLoading = false;
        this.pageLoading = false;
      }
    },
    showToast(message, status = "success") {
      this.toastMessage = message;
      this.toastColor = status === "error" ? "red darken-2" : "green darken-2";
      this.toastVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.autopricing-admin-wrapp {
  width: 100%;
  max-width: 1600px;
  margin: 32px auto;
  padding: 0 40px;
}

.payout-configs-card {
  border: 1px solid #e5e7eb !important;

  .pc-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    padding: 24px 24px 4px;
  }

  .pc-title {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: #111827;
    line-height: 1.4;
  }

  .pc-count {
    margin-left: 10px;
    padding: 2px 10px;
    border-radius: 9999px;
    background: #f3f4f6;
    color: #4b5563;
    font-size: 12px;
    font-weight: 600;
  }

  .pc-subtitle {
    margin: 4px 0 0;
    max-width: 640px;
    font-size: 13px;
    line-height: 1.5;
    color: #6b7280;
  }

  .pc-toolbar {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    padding: 16px 24px 20px;
    border-bottom: 1px solid #f3f4f6;
  }

  .pc-filter-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .pc-filter-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #9ca3af;
  }

  .pc-toggle {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;

    .v-btn {
      background: #fff;
      border-color: #e5e7eb !important;
      letter-spacing: 0;
      font-weight: 500;
      color: #4b5563;
    }
  }

  .pc-search {
    flex: 1 1 260px;
    min-width: 240px;
  }

  .pc-search-field ::v-deep .v-input__slot {
    border-radius: 8px;

    fieldset {
      border-color: #e5e7eb;
    }
  }

  .pc-table {
    padding: 0 8px;

    ::v-deep thead th {
      text-transform: uppercase;
      font-size: 11px !important;
      font-weight: 600;
      letter-spacing: 0.06em;
      color: #9ca3af !important;
      white-space: nowrap;
      border-bottom: 1px solid #f3f4f6 !important;
    }

    ::v-deep tbody td {
      height: 46px !important;
      font-size: 13.5px !important;
      color: #374151;
      border-bottom: 1px solid #f9fafb !important;
    }

    ::v-deep tbody tr:hover {
      background: #f9fafb !important;
    }

    ::v-deep .v-data-footer {
      border-top: 1px solid #f3f4f6;
      font-size: 12px;
      color: #6b7280;
    }
  }

  .pc-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 9999px;
    font-size: 11.5px;
    font-weight: 600;
    line-height: 1.5;
    white-space: nowrap;

    &--indigo {
      background: #eef2ff;
      color: #4338ca;
    }

    &--teal {
      background: #f0fdfa;
      color: #0f766e;
    }

    &--slate {
      background: #f1f5f9;
      color: #475569;
    }

    &--blue {
      background: #eff6ff;
      color: #1d4ed8;
    }

    &--orange {
      background: #fff7ed;
      color: #c2410c;
    }
  }

  .pc-date {
    font-size: 12.5px;
    color: #6b7280;
    font-variant-numeric: tabular-nums;
  }
}
</style>
